module.exports = __webpack_public_path__ + "img/fm-f-Path 2@3x.43037d49.png";